/**
 * Large counts as K / M / B (owner, 2026-10-06): `12,450,000` → `12.5M`.
 *
 * **Three significant figures, trailing zeros dropped** — `12.5M`, `950K`,
 * `1.24B`, `8.3M` — so a label is at most five characters and two labels a
 * step apart still differ. Below 10,000 a number is left to the caller's own
 * format: a thousand is short enough already, and `1.2K` beside `950` reads
 * as two different units.
 */

const UNITS: ReadonlyArray<[number, string]> = [
  [1e9, "B"],
  [1e6, "M"],
  [1e3, "K"],
];

/** Where compact starts — below this a number keeps its own format. */
export const COMPACT_FROM = 10_000;

export function compactNumber(y: number): string {
  if (!Number.isFinite(y)) return "";
  const size = Math.abs(y);
  for (const [unit, suffix] of UNITS) {
    if (size >= unit) {
      const v = y / unit;
      const a = Math.abs(v);
      // 999.6K rounds to "1000K"; carry it into the next unit up instead.
      if (a >= 999.5 && suffix !== "B") return compactNumber(Math.sign(y) * unit * 1000);
      const digits = a >= 100 ? 0 : a >= 10 ? 1 : 2;
      return `${Number(v.toFixed(digits))}${suffix}`;
    }
  }
  return String(Number(y.toFixed(2)));
}
